import {
  adaptStoreToFilterPath,
  adaptStoreToPageURL,
} from 'src/adapters/storeToPageURL/adaptStoreToPageURL';
import { buildListingsURL } from 'src/adapters/storeToPageURL/buildListingsURL';
import type { ReduxApplicationState } from 'src/redux/combinedReducer';
import { selectListingsBasePathParts } from 'src/redux/productsQuery/selectors/selectors';
import { buildListingsBasePath } from './buildListingsBasePath';

export const buildTaxonomyListingURL = (state: ReduxApplicationState): string => {
  const { levels, pathname, routeLiteral } = selectListingsBasePathParts(state);
  const basePath = levels.length > 0 ? buildListingsBasePath(routeLiteral, levels) : pathname;
  const filterPath = adaptStoreToFilterPath(state);
  const params = adaptStoreToPageURL(state, state.productsQuery.page);
  return buildListingsURL(basePath, filterPath, params, state.navigation.hash);
};
